import React, { useState, useEffect } from 'react';

import Utils from "../../utilities/Utils";
import { useHistory } from "react-router-dom";
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";

import EmpresaService from '../../service/EmpresaService';

const empresaService = new EmpresaService(); // Create an instance of EmpresaService

const ListarEmpresa = () => {
    const [empresa, setEmpresa] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [activeDialog, setActiveDialog] = useState(false);
    const [toDelete, setToDelete] = useState(null);
    const [toActive, setToActive] = useState(null);

    const iss = localStorage.getItem('iss');
    let roles = JSON.parse(localStorage.getItem('roles'));

    useEffect(() => {
        initFilters1();
        initEmpresa();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const initEmpresa = () => {
        setLoading1(true);
        empresaService.listAllEmpresa(iss).then(data => {
            setEmpresa(data.data.rows);
            setLoading1(false);
        });
    }

    const initFilters1 = () => {
        setFilters1({
            'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'cnpj': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        });
    }

    const irParaCadastro = () => {
        if (roles.postEmpresa)
            history.push('/empresa/cadastrar');
    }

    const abreModalDeletar = (toDelete) => {
        console.log(toDelete);
        setToDelete(toDelete);
        setDeleteDialog(true);
    }

    const abreModalAtivar = (empresa) => {
        console.log(empresa);
        setToActive(empresa);
        setActiveDialog(true);
    }

    const handleDeleteTipo = () => {
        if (roles.deleteEmpresa) {
            setLoading1(true)
            empresaService.deleteEmpresa(iss, toDelete.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Empresa excluída com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initEmpresa();
            }, error => {
                showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar empresa' });
            }).finally(() => { setLoading1(false) });

        }
    }

    const handleActiveUsuario = () => {
        if (roles.activeEmpresa) {
            setLoading1(true)
            let status = toActive.ativo ? 0 : 1;
            empresaService.activeEmpresa(iss, toActive.id, status).then((data) => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: `Empresa ${status ? 'ativada' : 'inativada'} com sucesso` });
                setLoading1(false);
                hideModalActive();
                initEmpresa();
            }, error => {
                showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao ativar/destivar empresa' });
            }).finally(() => { setLoading1(false) });

        }
    }


    const editar = (tipoParaEditar) => {
        if (roles.getEmpresa)
            history.push('/empresa/editar/' + tipoParaEditar.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setToDelete(null);
    }

    const hideModalActive = () => {
        setActiveDialog(false);
        setToActive(null);
    }


    const dataBody = (rowData, column) => {
        if (column.field === 'field_1' && rowData.cnpj)
            return <span>{Utils.formatCnpj(rowData.cnpj)}</span>
        if (column.field === 'field_2' && rowData.telefone)
            return <span>{Utils.formatTelefone(rowData.telefone)}</span>
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {roles.deleteEmpresa ? <Button icon="pi pi-trash" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {roles.getEmpresa ? <Button icon="pi pi-pencil" onClick={() => { editar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const statusBody = (rowData) => {
        return roles.activeUser ? <Button icon={rowData.ativo ? 'pi pi-check' : 'pi pi-times'} onClick={() => { abreModalAtivar(rowData) }} className="p-button-rounded  mr-2 mb-2" style={{ backgroundColor: rowData.ativo ? 'green' : 'red', color: 'black' }} /> : <></>
    }

    const deleteFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteTipo} />
        </>
    );

    const activeDialogFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalActive} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleActiveUsuario} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {roles.postEmpresa ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Empresas</h5>
                    <DataTable value={empresa} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma empresa cadastrado.">
                        <Column sortable field="name" header="Nome Fantasia" filter filterPlaceholder="Procurar por prestador" style={{ minWidth: '12rem' }} />
                        <Column sortable body={dataBody} header="CNPJ" filter filterPlaceholder="Procurar por toDelete" style={{ minWidth: '12rem' }} />
                        <Column sortable field="telefone" header="Telefone" filter filterPlaceholder="Procurar por descrição" style={{ minWidth: '12rem' }} />
                        <Column sortable field="cidade" header="Cidade" style={{ minWidth: '12rem' }} />
                        <Column sortable field="estado" header="Estado" style={{ minWidth: '12rem' }} />
                        <Column sortable field="ativo" body={statusBody} header="Ativo" style={{ width: '1rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Deletar" modal footer={deleteFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja excluir a empresa selecionada?</span>
                </div>
            </Dialog>

            <Dialog visible={activeDialog} style={{ width: '450px' }} header="Ativar/Desativar" modal footer={activeDialogFooter} onHide={hideModalActive}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja ativar/destivar o usuário selecionado?</span>
                </div>
            </Dialog>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarEmpresa, comparisonFn);
